import { useContext } from 'react'
import { WorkoutOverrideModalContext } from 'components/Modals/Popups/WorkoutOverrideModal'

import NumberInput from 'components/Input/NumberInput'

export default function SetsOverrideInput({ phaseIndex }) {

    const { allowEditing, GetWorkoutTemplateDisplayData, HandleOverrideChange } = useContext(WorkoutOverrideModalContext)

    const setsDisplayData = GetWorkoutTemplateDisplayData('one-off-sets-override', phaseIndex)

    const HandleSetsChange = (phaseIndex, value) => {
        HandleOverrideChange(
            'one-off-sets-override',
            phaseIndex, 
            0, // slot index not needed for sets override
            value
        )
    }

    return (
        <>
            <p>Sets: </p>

            {allowEditing &&
                <div className='w-20'>
                    <NumberInput
                        value={setsDisplayData.value}
                        onChange={(value) => HandleSetsChange(phaseIndex, value)}
                        className={setsDisplayData.overrideApplied ? 'bg-orange-100' : ''}
                    />
                </div>
            }

            {!allowEditing &&
                <div className='w-20'>
                    <p>{setsDisplayData.value}</p>
                </div>
            }
        </>
    )
}